import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Maximize Business Growth by Collaborating with Our Flutter App
              Development Company in Dubai
            </h2>
            <p>
              This is your chance to leverage the growth potential of your
              business by partnering with our leading Flutter app development
              company in Dubai. We enable businesses to easily compete in the
              digital market with our customized mobile solutions based on the
              latest Flutter technology.
            </p>
            <p>
              From the basic concept of your app to its efficient execution
              towards supremacy, we are committed to delivering next-gen
              solutions that will revolutionize your business presence.
            </p>
            <p>
              So, consult with us to transform your ideas into mobile
              experiences that create a difference to boost your business
              forward in the competitive market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../images/location_new/fold11/flutter_dubai.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
